var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@lucidlink/uicore';
import { WorkspaceOnboarding } from '../../../WorkspaceOnboarding';
import { WorkspaceNavigation } from './components';
export const AppSidebar = ({ shouldShowOnboardingWidget, workspace, }) => (_jsxs(Box, { as: "nav", justify: "between", orientation: "vertical", shrink: 0, children: [_jsx(WorkspaceNavigation, { workspace: workspace }), shouldShowOnboardingWidget && _jsx(WorkspaceOnboarding, {})] }));
_react_refresh_temp_1 = AppSidebar;
$RefreshReg$(_react_refresh_temp_1, "AppSidebar");
